var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.75005 14.1667C8.53671 14.1667 8.32338 14.085 8.16088 13.9225C7.83505 13.5967 7.83505 13.07 8.16088 12.7442L10.915 9.99004L8.26505 7.24588C7.94588 6.91421 7.95505 6.38671 8.28588 6.06754C8.61755 5.74838 9.14505 5.75754 9.46421 6.08754L12.6825 9.42088C12.9984 9.74838 12.9942 10.2675 12.6725 10.5892L9.33921 13.9225C9.17671 14.085 8.96338 14.1667 8.75005 14.1667Z",
    fill: "#434656"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRight);
export default __webpack_public_path__ + "static/media/chevron-right.484591ebacbe65f2e350a98c016593d6.svg";
export { ForwardRef as ReactComponent };